"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Credits_1 = require("./Credits");
exports.Credits = Credits_1.default;
var creditsOptions_1 = require("./creditsOptions");
exports.creditsOptions = creditsOptions_1.default;
//# sourceMappingURL=index.js.map